{
  "SET_NEW_PASSWORD": {
    "TITLE": "新しいパスワードを設定",
    "PASSWORD": {
      "LABEL": "パスワード",
      "PLACEHOLDER": "パスワード",
      "ERROR": "パスワードが短すぎます"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "パスワードの確認",
      "PLACEHOLDER": "パスワードの確認",
      "ERROR": "パスワードが一致しません"
    },
    "API": {
      "SUCCESS_MESSAGE": "パスワードは正常に変更されました.",
      "ERROR_MESSAGE": "Woot Serverに接続できませんでした。もう一度お試しください。"
    },
    "CAPTCHA": {
      "ERROR": "認証が期限切れです。再度キャプチャを解いてください。"
    },
    "SUBMIT": "送信"
  }
}
